import { DatiOrdiniEsolver, Ordine, Organizzazione } from './_Index';

export class FileEsolver {
    dataEvento?: number;
    organizzazione: Organizzazione;
    lavorazioni: DatiOrdiniEsolver;
    ordine: Ordine;
}
